var React = require('react');

function LoaderAnimation (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"loader","cx":"28","cy":"28","r":"26","style":{"fill":"none","stroke":"#f16e00","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"3"},"key":0}),React.createElement("style",{"key":1},"\n\t\t#loader {\n\t\t\tstroke-dasharray: 67.84 101.76;\n\t\t  \tanimation: dash 2.6s linear infinite;\n\t\t\ttransform-origin: center center;\n\t\t\trepeat: \n\t\t}\n\t\t@keyframes dash {\n\t\t30% {\n\t\t\tstroke-dasharray: 0.00 300;\n\t\t\ttransform: rotate(180deg);\n\n\t\t}\n\t\t100% {\n\t\t\tstroke-dasharray: 67.84 101.76;\n\t\t\ttransform: rotate(360deg);\n\t\t}\n\t\t}\n\n\t")]);
}

LoaderAnimation.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56"};

module.exports = LoaderAnimation;

LoaderAnimation.default = LoaderAnimation;
